import QAResumeRepository from "../../repositories/qa_resume.repository";
import QAResumeEntity from "../../entities/qa_resume.entity";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/error.entity";
import SearchResultEntity from "../../entities/search_result.entity";

interface Props {
    qaResumeRepository: QAResumeRepository;
}

export default class SearchQAResumesUseCase {
    private _qaResumeRepository: QAResumeRepository;

    constructor(_: Props) {
        this._qaResumeRepository = _.qaResumeRepository;
    }

    public call = async (_: {
        start_date?: string;
        end_date?: string;
        page_number: number;
        page_size: number;
        call_state?: string;
        sentiment?: string;
        audio_name?: string;
        human_agent_id?: string;
        human_agent_name?: string;
        query?: string;
    }): Promise<Either<ErrorEntity, SearchResultEntity<QAResumeEntity>>> => {
        return this._qaResumeRepository.search({
            from: _?.start_date ? new Date(_.start_date) : undefined,
            to: _?.end_date ? new Date(_.end_date) : undefined,
            page: _.page_number,
            itemsPerPage: _.page_size,
            call_state: _.call_state,
            sentiment: _.sentiment,
            audio_name: _.audio_name,
            humanAgentId: _.human_agent_id,
            human_agent_name: _.human_agent_name,
            query: _.query,
        });
    };    
    
}

export const SearchQAResumesUseCaseName = "SearchQAResumesUseCase";